<template>
  <div>
    <OrdersSuperiorMenu></OrdersSuperiorMenu>
    <v-card
      v-if="!orders.length"
      class="ma-10"
      outlined
    >
      <v-card-title> Todavía no se ha realizado ningún pedido. </v-card-title>
      <v-card-text>
        Continúa comprando
        <router-link to="/articles">aquí</router-link>
      </v-card-text>
    </v-card>
    <div v-else>
      <OrdersList></OrdersList>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import OrdersList from "@/components/utils/OrdersList.vue";
import OrdersSuperiorMenu from "../layout/OrdersSuperiorMenu.vue";
export default {
  components: { OrdersList, OrdersSuperiorMenu },
  data() {
    return {};
  },

  computed: {
    ...mapState(["orders"]),
  },

  methods: {
    ...mapGetters(["numberOfArticlesInCart"]),
  },
};
</script>
